import { render, staticRenderFns } from "./ResponsiveFieldsForm.vue?vue&type=template&id=04db7862&"
import script from "./ResponsiveFieldsForm.vue?vue&type=script&lang=js&"
export * from "./ResponsiveFieldsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports